import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError, from } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { TitleService } from '../services/title/title.service';
import { AuthenticationService } from '../../user/services/authentication.service';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
    constructor(
        private titleService: TitleService,
        private router: Router,
        private authenticationService: AuthenticationService,
    ) {}

    public intercept(
        request: HttpRequest<any>,
        handler: HttpHandler
    ): Observable<HttpEvent<any>> {
        return handler.handle(request)
            .pipe(
                catchError((error: HttpErrorResponse) => this.handleApiError(error))
            );
    }

    private handleApiError(error: HttpErrorResponse): Observable<any> {
        return throwError(error)
            .pipe(
                catchError((error) => {
                    this.redirectUser(error);
                    return throwError(error);
                })
            );
    }

    private redirectUser(error: HttpErrorResponse) {
        if (!this.authenticationService.isAuthenticated &&
            error.status === 401 &&
            this.titleService.title !== 'Login'
        ) {
            this.router.navigateByUrl('');
        }
    }
}
